import { Radio } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import useFetch from "../../../hooks/useAxios";
import Button from "../../shared/Button";
import Input from "../../shared/Input";
import InputWithlabelin from "../../shared/InputWithlabelin";
import Textarea from "../../shared/Textarea";

const CreateStep2 = ({ prevStep, nextStep }) => {
  const { updatePlaceDetail, createInfoData,apiUpdateResideces,setIsEditPlaceCompleter } = useCreatePlace();

  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm({
    // defaultValues:{
    //   title:createInfoData.title,
    //   foundation_size:createInfoData.foundation_size ,
    //   area_size: createInfoData.area_size,
    //   floors: createInfoData.floors,
    //   description: createInfoData.description
    // }
    defaultValues: useMemo(
      () => {
        return createInfoData.stepTwo;
      },
      [createInfoData]
    )
  });

  const [typeResidence, setTypeResidence] = useState([]);
  const apiCreatePlace = useFetch({
    method: "get",
    url: "api/residences-types",
    noHeader: false,
    trigger: true,

    argFunc: res => {
      
      setTypeResidence(res);
      //  console.log(JSON.parse(typeResidence))
    }
  });
  const [space, setspace] = useState(createInfoData.stepTwo.space);
  const [kind, setkind] = useState(createInfoData.stepTwo.type);
  useEffect(() => {
    setkind(createInfoData.stepTwo.type)
    reset({
      title: createInfoData.stepTwo.title,
      foundation_size: createInfoData.stepTwo.foundation_size,
      area_size: createInfoData.stepTwo.area_size,
      floors: createInfoData.stepTwo.floors,
      description: createInfoData.stepTwo.description
    });
    setspace(createInfoData.stepTwo.space)
  }, [createInfoData]);
  console.log("createInfoData",createInfoData)

  const onChange = e => {
    setspace(e.target.value);
    console.log(space)
  };
  const onChangekind = e => {
    setkind(e.target.value);
    console.log(kind)
  };
  const {id}=useParams()

  const onSubmit = data => {
    if(kind === ""){
     toast.error("انتخاب نوع اقامتگاه اجباری است.")
    }else{
      updatePlaceDetail("stepTwo", {
        space: space,
        title: data.title,
        type: kind,
        foundation_size: data.foundation_size,
        area_size: data.area_size,
        floors: data.floors,
        description: data.description
      });
   nextStep();
    }
  
  console.log(createInfoData)
  };
  const update = (data) => {
    if(kind === ""){
      toast.error("انتخاب نوع اقامتگاه اجباری است.")
     }else{
       updatePlaceDetail("stepTwo", {
         space: space,
         title: data.title,
         type: kind,
         foundation_size: data.foundation_size,
         area_size: data.area_size,
         floors: data.floors,
         description: data.description
       });
       setIsEditPlaceCompleter(true);
    
      }
  };
  return (
    <div className="createsteps CreateStep2">
      <h2>مشخصات کلی اقامتگاه</h2>
      <p>
        مشخصات کلی بومگردی که بخش مهمی از صفحه آگهی و پیش‌نمایش آن در صفحه جستجو
        را شامل می‌شود. مهمان‌ها در هنگام مقایسه و انتخاب اقامتگاه‌ها به این
        مشخصات توجه می‌کنند.
      </p>
      <div className="mt-[50px]">
        <form >
          <Input
            name="title"
            control={control}
            errors={errors}
            placeholder=" عنوان اقامتگاه"
            label="عنوان اقامتگاه"
            className="seconadary-input"
            register={{
              required: " عنوان اقامتگاه اجباری است"
            }}
          />
          <div className="createsteps--radiogroup mt-[50px] ">
            <h6>فضای اقامتگاه</h6>
            <Radio.Group
              defaultValue={createInfoData.stepTwo.space}
              onChange={onChange}
              value={space}
            >
              <div className="createstep2--grid">
                <div
                  className={`createsteps--radiogroupbox ${space === "closed"
                    ? "createsteps--radiogroupbox--active"
                    : ""}`}
                >
                  <Radio value="closed">
                    <div className={`createsteps--radiogrouplabel`}>
                      <h6>دربست</h6>
                      <p>
                        این ویلا دربست است و تمام فضاهای آن به طور کامل در
                        اختیار مهمان قرار خواهد گرفت.
                      </p>
                    </div>
                  </Radio>
                </div>
                <div
                  className={`createsteps--radiogroupbox ${space === "private_room"
                    ? "createsteps--radiogroupbox--active"
                    : ""}`}
                >
                  <Radio value="private_room">
                    <div className="createsteps--radiogrouplabel">
                      <h6>اتاق خصوصی</h6>
                      <p>
                        حداقل یک اتاق در اختیار میهمان قرار میگیرد و سایر فضاها
                        مثل آشپزخانه ، سالن یا حیاط مشترک است
                      </p>
                    </div>
                  </Radio>
                </div>
                <div
                  className={`createsteps--radiogroupbox ${space === "sime_closed"
                    ? "createsteps--radiogroupbox--active"
                    : ""}`}
                >
                  <Radio value="sime_closed">
                    <div className="createsteps--radiogrouplabel">
                      <h6>نیمه دربست</h6>
                      <p>
                        فضای یک واحد مسکونی در اختیار میهمان قرار میگیرد ولی
                        برخی از فضا ها با سایر میهمان ها مشترک است مثل ورودی و
                        یا حیاط
                      </p>
                    </div>
                  </Radio>
                </div>
                <div
                  className={`createsteps--radiogroupbox ${space === "shared_room"
                    ? "createsteps--radiogroupbox--active"
                    : ""}`}
                >
                  <Radio value="shared_room">
                    <div className="createsteps--radiogrouplabel">
                      <h6>اتاق مشترک</h6>
                      <p>
                        فضای یک اتاق مشترک بین چند میهمان اختصاص میابد بطور مثال
                        حالتی مشابه به یک هاستل چند تخته
                      </p>
                    </div>
                  </Radio>
                </div>
              </div>
            </Radio.Group>
          </div>
          <div className="createsteps--radiogroup mt-[50px] createsteps--radiogroup--kind">
            <h6>نوع آپارتمان</h6>
            <Radio.Group
              defaultValue={createInfoData.stepTwo.type}
              onChange={onChangekind}
              value={kind}
            >
              <div className="grid md:grid-cols-4 grid-cols-2  md:gap-[32px] gap-[16px]">
                {typeResidence.map(i =>
                  <div
                    className={`createsteps--radiogroupbox ${kind === i.value
                      ? "createsteps--radiogroupbox--active"
                      : ""}`}
                  >
                    <Radio value={i.value}>
                      <h5>
                        {i.label}
                      </h5>
                    </Radio>
                  </div>
                )}
              </div>
            </Radio.Group>
          </div>
          <div className="createsteps--grid3 mt-[50px]">
            <InputWithlabelin
              name="area_size"
              control={control}
              errors={errors}
              placeholder=" مثال ۲۰۰ متر"
              label="متراژ زمین اقامتگاه"
              className="seconadary-input"
              labelIn="متر مربع"
              type="number"
              register={{
                required: " متراژ زمین اقامتگاه اجباری است"
              }}
            />
            <InputWithlabelin
              name="foundation_size"
              control={control}
              errors={errors}
              placeholder="مثال ۲۰۰ متر"
              label="متراژ زیر بنای اقامتگاه"
              className="seconadary-input"
              labelIn="متر مربع"
              type="number"
              register={{
                required: " متراژ زیر بنای اقامتگاه اجباری است"
              }}
            />
            <InputWithlabelin
              name="floors"
              control={control}
              errors={errors}
              label="تعداد طبقه ی اقامتگاه"
              placeholder=" 7"
              className="seconadary-input"
              labelIn="طبقه"
              type="number"
              register={{
                required: "  تعداد طبقه ی اقامتگاه اجباری است"
              }}
            />
          </div>
          <Textarea
            name="description"
            control={control}
            errors={errors}
            label="درباره اقامتگاه"
            placeholder=" در اینجا نکات ضعف و قوتی را که میهمان شما باید بداند را بنویسید"
            className="seconadary-input mt-[50px]"
            rows="5"
            register={{
              required: "  درباره اقامتگاه اجباری است"
            }}
          />
          <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
         { id && <Button  onClick={handleSubmit((d) =>update(d))} type="submit" varient="primary"> 
                بروزرسانی اقامتگاه
              </Button>}
            <Button
              varient="gray"
              onClick={() => {
                prevStep();
              }}
            >
              مرحله قبلی
            </Button>

            <Button onClick={handleSubmit((d) =>onSubmit(d))} varient="primary" type="submit">
              مرحله بعدی
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateStep2;
